module.exports = __webpack_public_path__ + "static/media/preview.4c1a39cd.png";